/**
 * Widget 状态管理 Store
 *
 * 集成事件总线，在状态变化时触发事件
 */

import { create } from 'zustand';
import { WidgetConfig } from '../config/widget.types';
import { DEFAULT_CONFIG } from '../config/default.config';
import { getEventBus } from '../services/events';

/**
 * Widget Store 状态接口
 */
interface WidgetStore {
  // UI 状态
  isWidgetOpen: boolean;
  isLauncherVisible: boolean;

  // 配置
  config: WidgetConfig;

  // 操作
  openWidget: () => void;
  closeWidget: () => void;
  toggleWidget: () => void;
  updateConfig: (config: Partial<WidgetConfig>) => void;

  // 生命周期
  initialize: (config: WidgetConfig) => void;
  destroy: () => void;
}

/**
 * Widget Store
 */
export const useWidgetStore = create<WidgetStore>((set, get) => ({
  // 初始状态
  isWidgetOpen: false,
  isLauncherVisible: true,
  config: DEFAULT_CONFIG,

  // 打开 Widget
  openWidget: () => {
    set({
      isWidgetOpen: true,
      isLauncherVisible: false
    });
    // 触发事件
    getEventBus().emit('opened');
  },

  // 关闭 Widget
  closeWidget: () => {
    set({
      isWidgetOpen: false,
      isLauncherVisible: true
    });
    // 触发事件
    getEventBus().emit('closed');
  },

  // 切换 Widget
  toggleWidget: () => {
    const { isWidgetOpen } = get();
    set({
      isWidgetOpen: !isWidgetOpen,
      isLauncherVisible: isWidgetOpen
    });
    // 触发事件
    if (!isWidgetOpen) {
      getEventBus().emit('opened');
    } else {
      getEventBus().emit('closed');
    }
  },

  // 更新配置
  updateConfig: (newConfig) => {
    set(state => ({
      config: { ...state.config, ...newConfig }
    }));
  },

  // 初始化
  initialize: (config) => {
    set({
      config: { ...DEFAULT_CONFIG, ...config },
      isWidgetOpen: config.defaultOpen || false,
      isLauncherVisible: !config.defaultOpen && config.showLauncher !== false
    });
  },

  // 销毁
  destroy: () => {
    set({
      isWidgetOpen: false,
      isLauncherVisible: true,
      config: DEFAULT_CONFIG
    });
  },
}));
